import React from 'react'
import { Navigate } from 'react-router'
import { PATH_PUBLISHED } from './apps-list'

const AppDashboard = () => <Navigate to={`/apps/${PATH_PUBLISHED}`} replace />

export default AppDashboard
